import { Box, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { ReactComponent as InventoryIcon } from "../../../../../icons/icon_files/environment.svg";
import { ComplexEntityTypes } from "../../../../../utils/constants";
import { EntityTypeInfo } from "../../../environment/components/constants";
import PotentialCollapsibleSection from "./PotentialCollapsibleSection";

export const INVENTORY_SECTION_CLASSNAME = "inventory-section";

export default function InventorySection({ integrationInfo }) {
  const colors = useColors();

  const types = integrationInfo.collectors;

  const descriptionByEntityType = {
    [ComplexEntityTypes.HOST]:
      "Analyzes compute resources and workload activity to detect excessive permissions, misused compute, misconfigurations, leaked tokens, or anomalous workload behaviors.",
    [ComplexEntityTypes.USER]:
      "Maps users, roles, and permissions to detect privilege escalation risks and visualize relationships across authentication methods, access paths, and entitlements.",
    [ComplexEntityTypes.SERVER]:
      "Analyzes server configurations and connected services, linking them to identities to surface exposed endpoints, misused servers, unmanaged secrets, configuration drift, or unpatched systems.",
    [ComplexEntityTypes.DATA_STORE]:
      "Identifies databases, data stores, and sensitive assets, linking them to exposed users and applications to flag weak access controls and data exposure risks.",
    [ComplexEntityTypes.NONHUMAN_IDENTITY]:
      "Identifies service accounts and machine identities, monitoring their permissions, token usage, and activity to detect misuse, over-permissioning, or anomalous behaviors.",
    [ComplexEntityTypes.APP]:
      "Maps applications, integrations, and third-party services to uncover excessive permissions, insecure tokens, and risky inter-app dependencies.",
  };

  return (
    <PotentialCollapsibleSection title="Inventory Mapping" Icon={InventoryIcon}>
      <div
        className={INVENTORY_SECTION_CLASSNAME}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          padding: "8px 0",
        }}
      >
        {types.map((entityType) => (
          <Box key={entityType} display="flex" gap={1} flexDirection="column">
            <Box display="flex" gap={"10px"} alignItems="center">
              <SvgToIcon
                IconLogo={EntityTypeInfo[entityType].icon}
                width="20px"
                style={{ color: colors.action_primary }}
              />
              <Typography variant="subtitle2" color={colors.text_primary}>
                {EntityTypeInfo[entityType].title} Collector
              </Typography>
            </Box>
            <Typography variant="body2" color={colors.text_secondary}>
              {descriptionByEntityType[entityType]}
            </Typography>
          </Box>
        ))}
      </div>
    </PotentialCollapsibleSection>
  );
}
